// Public routes
export const SIGN_IN = '/sign-in';

// Admin routes
export const ADMIN = '/admin';
export const ADMIN_DASHBOARD = '/admin/dashboard';
export const ADMIN_REFERRERS = '/admin/referrers';
export const ADMIN_REFERRER_DETAIL = '/admin/referrers/$id';
export const ADMIN_REFERRER_NEW = '/admin/referrers/new';
/** «Nuovo rivenditore» guidato in 4 passi. */
export const ADMIN_REFERRER_NEW_PARTNER = '/admin/referrers/new-partner';
export const ADMIN_REFERRER_EDIT = '/admin/referrers/edit/$id';
export const ADMIN_ADVISORS = '/admin/advisors';
/** Dettaglio del commercialista sopra la lista. */
export const ADMIN_ADVISOR_DETAIL = '/admin/advisors/$id';
export const ADMIN_ADVISOR_NEW = '/admin/advisors/new';
export const ADMIN_ADVISOR_EDIT = '/admin/advisors/edit/$id';
export const ADMIN_ADMINS = '/admin/admins';
export const ADMIN_ADMIN_NEW = '/admin/admins/new';
export const ADMIN_ADMIN_EDIT = '/admin/admins/edit/$id';
export const ADMIN_FOREIGN_VENDORS = '/admin/foreign-vendors';
export const ADMIN_FOREIGN_VENDOR_NEW = '/admin/foreign-vendors/new';
export const ADMIN_FOREIGN_VENDOR_EDIT = '/admin/foreign-vendors/edit/$id';
export const ADMIN_COMMISSIONS = '/admin/commissions';
export const ADMIN_COMMISSION_DETAIL = '/admin/commissions/$id';
export const ADMIN_TENANTS = '/admin/tenants';
export const ADMIN_TENANT_DETAIL = '/admin/tenants/$id';
export const ADMIN_AI_USAGE = '/admin/ai-usage';
export const ADMIN_SERVICE_USAGE = '/admin/service-usage';
/** Volumi del contratto di un tenant, sopra la lista. */
export const ADMIN_SERVICE_USAGE_DETAIL = '/admin/service-usage/$tenantId';
/** Vista secondaria: l'utilizzo aggregato per tipo di servizio. */
export const ADMIN_SERVICE_USAGE_BY_SERVICE = '/admin/service-usage/by-service';
export const ADMIN_SYSTEM_MONITOR = '/admin/system-monitor';
export const ADMIN_SYSTEM_MONITOR_RUNS = '/admin/system-monitor/runs';
/** Dettaglio del job sopra la lista delle esecuzioni (sheet da rotta). */
export const ADMIN_SYSTEM_MONITOR_RUN_DETAIL = '/admin/system-monitor/runs/$id';
export const ADMIN_SYSTEM_MONITOR_FLOW_DETAIL =
  '/admin/system-monitor/flow/$flowId';
export const ADMIN_SYSTEM_MONITOR_METRICS = '/admin/system-monitor/metrics';
export const ADMIN_SYSTEM_MONITOR_QUEUES = '/admin/system-monitor/queues';
export const ADMIN_SYSTEM_MONITOR_OVERVIEW = '/admin/system-monitor/overview';
export const ADMIN_SYSTEM_MONITOR_REDIS = '/admin/system-monitor/redis';
export const ADMIN_APPOINTEE = '/admin/appointee';
/** Pannello delle credenziali dell'incaricato, sopra la pagina. */
export const ADMIN_APPOINTEE_CREDENTIALS = '/admin/appointee/credentials';
/** Dettaglio del tenant delegato, sopra la pagina dell'incaricato. */
export const ADMIN_APPOINTEE_TENANT_DETAIL = '/admin/appointee/$id';
export const ADMIN_ERROR_LOGS = '/admin/error-logs';
export const ADMIN_ERROR_LOG_DETAIL = '/admin/error-logs/$id';
export const ADMIN_ACUBE_JOBS = '/admin/acube-jobs';
export const ADMIN_ACUBE_JOB_DETAIL = '/admin/acube-jobs/$id';
export const ADMIN_ACUBE_PAYMENTS = '/admin/acube-payments';
/** Dettaglio di una riga del registro ACube, sopra la lista. */
export const ADMIN_ACUBE_PAYMENT_DETAIL = '/admin/acube-payments/$id';
/** Dettaglio di un bonifico senza riga nel registro (id del `SepaPayment`). */
export const ADMIN_SEPA_PAYMENT_DETAIL = '/admin/acube-payments/sepa/$id';
export const ADMIN_NOTIFICATIONS = '/admin/notifications';
/** Dettaglio della notifica sopra la lista (sheet da rotta). */
export const ADMIN_NOTIFICATION_DETAIL = '/admin/notifications/$id';
/** Modifica dei testi di una notifica non ancora inviata, sopra la lista. */
export const ADMIN_NOTIFICATION_EDIT = '/admin/notifications/edit/$id';
export const ADMIN_TICKETS = '/admin/tickets';
/** Deep-link al dettaglio: la coda montata con la sheet gia' aperta. */
export const ADMIN_TICKET_DETAIL = '/admin/tickets/$id';
export const ADMIN_MCP_CLIENTS = '/admin/mcp-clients';
/** Dettaglio di un client MCP, sopra la lista. */
export const ADMIN_MCP_CLIENT_DETAIL = '/admin/mcp-clients/$id';
export const ADMIN_CONTRACTS = '/admin/contracts';
export const ADMIN_CONTRACT_DETAIL = '/admin/contracts/$id';
export const ADMIN_CONTRACT_NEW = '/admin/contracts/new';
export const ADMIN_CONTRACT_EDIT = '/admin/contracts/$id/edit';
export const ADMIN_INFRASTRUCTURE_COSTS = '/admin/infrastructure-costs';
export const ADMIN_PRODUCT_RELEASES = '/admin/releases';

// Referrer routes
export const REFERRER = '/referrer';
export const REFERRER_DASHBOARD = '/referrer/dashboard';
export const REFERRER_TENANTS = '/referrer/tenants';
export const REFERRER_TENANT_DETAIL = '/referrer/tenants/$id';
export const REFERRER_COMMISSIONS = '/referrer/commissions';
export const REFERRER_COMMISSION_DETAIL = '/referrer/commissions/$id';
export const REFERRER_CONTRACTS = '/referrer/contracts';
export const REFERRER_CONTRACT_DETAIL = '/referrer/contracts/$id';
export const REFERRER_CONTRACT_NEW = '/referrer/contracts/new';
export const REFERRER_CONTRACT_EDIT = '/referrer/contracts/$id/edit';
export const REFERRER_INFRASTRUCTURE_COSTS = '/referrer/infrastructure-costs';
export const REFERRER_AGENTS = '/referrer/agents';
export const REFERRER_AGENT_DETAIL = '/referrer/agents/$id';
export const REFERRER_AGENT_NEW = '/referrer/agents/new';
export const REFERRER_PRODUCT_RELEASES = '/referrer/releases';

// Tenants
export const TENANTS = '/tenants';

// Support tickets
export const TICKETS = '/tickets';
